const getSsoConnectionRoleAssignments = (connection)=>connection.connectionType === 'saml' ? connection.saml_connection_implicit_role_assignments : connection.external_connection_implicit_role_assignments;
const getSsoGroupRoleAssignments = (connection)=>connection.connectionType === 'saml' ? connection.saml_group_implicit_role_assignments : connection.external_group_implicit_role_assignments;

export { getSsoConnectionRoleAssignments, getSsoGroupRoleAssignments };
//# sourceMappingURL=getSsoRoleAssignments.mjs.map
